

import React, { Component } from 'react';

export default class ProcessProductionTransaction extends React.Component {
  constructor(props) {
    super();
    this.state = {


    };
  }
  insufficientStock = () => {
    const insufficient = this.props.inputItems.find(item => {
      // // console.log('name')
      // console.log(item.name)
      // console.log('item.quantity')
      // console.log(item.quantity)
      // console.log('stock:')
      // console.log(this.props.getStockCountHandler(item.id, 'input_items'))
      // console.log('insufficient?:')
      // console.log(parseFloat(item.quantity) < parseFloat(this.props.getStockCountHandler(item.id, 'input_items')))
      return (parseFloat(item.quantity) > parseFloat(this.props.getStockCountHandler(item.id, 'input_items')))
    } )

    // if(insufficient) return true
    // return false;
    return (insufficient ? true : false)
  }
  render() {


    return (

      <div>
        {/* <label>Insufficient Stock: {String(this.insufficientStock()) }</label> */}
        <button className="btn btn-primary"
          disabled={this.props.disableProcessingSubmissionHandler()}
          onClick={() => this.props.processTransactionHandler(this.props.transactionType)}>
          Process
        </button>

        <div className={this.insufficientStock() ? '' : 'hide'}>
          <div className="alert alert-danger pull-left" role="alert">
            <button className="close" data-dismiss="alert" ></button>
            <strong>Warning: </strong>There is insufficient stock. <br />
            
            {
              this.props.inputItems.map( item => {
                return(
                  <li key={item.id}>
                    {item.name}. 
                    <label style={{ marginRight: '5px', marginLeft: '5px' }}>  On Hand: <b>{this.props.getStockCountHandler(item.id, 'input_items')} </b>  ,</label>
                    Minimum Required: <b>{prettyFloat(item.quantity)}</b>
                    
                  </li>
                )

                }

              )
            } 

          </div>
        </div>
      </div>

    );
  }
}